import React, {useEffect, useState} from "react";
import closeIcon from "../../img/closeIcon.svg";
import activeCheckBoxIcon from "../../img/activeCheckboxIcon.svg";
import emptyCheckBoxIcon from "../../img/emptyCheckboxIcon.svg";
import {useFormik} from "formik";
import * as Yup from "yup";
import CustomSelect from "../../utils/CustomSelect/CustomSelect";
import {axiosGetCargoCaseId} from "../../Api/ApiCargoCase/axiosGetCargoCaseId";
import useAxiosPrivate from "../../utils/CustomHooks/useAxiosPrivate/useAxiosPrivate";
import CustomSelectIsMulti from "../../utils/CustomSelectIsMulti/CustomSelectIsMulti";
import useAuth from "../../utils/CustomHooks/useAuth/useAuth";
import CargoDescriptionInputBlock
    from "./CargoDescriptionInputBlock/CargoDescriptionInputBlock";
import {usePostSignManCorrector} from "../../Api/Blockchain/axiosSign";
import {SignatureModal} from "../SendForSignature/SignatureModal/SignatureModal";
import SuccessModal from "../ReusedComponents/SuccessModal/SuccessModal";
import {findStatusDocument} from "../../utils/FindStatusDocument/FindStatusDocument";

const CreateDocSetManCorrectorModal = (props) => {

    const {
        onClose,
        onHandleAddManCorrector,
        selectedCargoCaseMan,
        cargoCaseDocId,
        isSelectedManCorrector,
        isModalMessageManCorrector
    } = props;

    const axiosPrivate = useAxiosPrivate();
    const { auth, dictionaryPorts, dictionaryVessels } = useAuth();
    const [activeTable, setActiveTable] = useState(true);
    const [isModalMessage, setModalMessage] = useState("");
    const [activeModalDigitalSign, setActiveModalDigitalSign] = useState(false);
    const [activeModalSuccess, setActiveModalSuccess] = useState(false);
    const [billOfLadingTable, setBillOfLadingTable] = useState([]);
    const [selectedBolsArray, setSelectedBolsArray] = useState([]);
    const [isSumBolGrossWeight, setSumBolGrossWeight] = useState(0);
    const [getCargoCaseCurrentMan, setCargoCaseCurrentMan] = useState([]);

    const optionsBols = getCargoCaseCurrentMan[0]?.bols.map(el => ({
        "value": el?.id,
        "label": el?.bookingRef,
        "grossWeight": el?.grossQuantity,
        "loadingOrderNumber": getCargoCaseCurrentMan[0]?.number,
        "loadingOrderDate": getCargoCaseCurrentMan[0]?.dateOfCreation,
        "isChecked": false
    }))

    const optionPorts = dictionaryPorts.map(el => ({
        "value": el?.id,
        "label": el?.name
    }))

    const optionVessels = dictionaryVessels.map(el => ({
        "value": el?.id,
        "label": el?.name
    }))

    const optionCorrectionType = [
        { value: 'MONETARY', label: 'MONETARY'},
        { value: 'NON_MONETARY', label: 'NON-MONETARY'}
    ];

    const postSignManCorrector = usePostSignManCorrector(axiosPrivate, cargoCaseDocId);

    const onHandleSignManCorrector = (body) => {
        if (body !== "" ) {
            postSignManCorrector(
                { id: selectedCargoCaseMan[0]?.id, manCorId: isSelectedManCorrector?.id, body },
                {
                    onSuccess: () => {
                        setModalMessage("Successfully signed!");
                        setActiveModalSuccess(true);
                    },
                    onError: (err) => {
                        console.error(err);
                    },
                    onFinally: () => setActiveModalDigitalSign(false),
                }
            );
        } else {
            setModalMessage("Signature required!");
        }
    }

    function onCloseModal(setActive) {
        onClose();
        setActive(false);
        setModalMessage("");
    }

    const onHandleCheckTable = (id) => {
            const currentBol = billOfLadingTable.find(el => el.bolId === id)
            if (currentBol.isChecked === false) {
                const changedBol = {...currentBol, isChecked: true}
                const updatedBolTable = billOfLadingTable.map(el => el.bolId === changedBol.bolId ? changedBol : el)
                setBillOfLadingTable(updatedBolTable)
            } else if (currentBol.isChecked === true) {
                const changedBol = {...currentBol, isChecked: false}
                const updatedBolTable = billOfLadingTable.map(el => el.bolId === changedBol.bolId ? changedBol : el)
                setBillOfLadingTable(updatedBolTable)
            }
        }

    useEffect(() => {
        let isLoading = true;

        if (cargoCaseDocId !== undefined) {
            axiosGetCargoCaseId(axiosPrivate, cargoCaseDocId, isLoading, setCargoCaseCurrentMan)
        } else {
            axiosGetCargoCaseId(axiosPrivate, selectedCargoCaseMan[0]?.cargoCase?.id, isLoading, setCargoCaseCurrentMan)
        }

        return () => {
            isLoading = false;
        }
    },[selectedCargoCaseMan, cargoCaseDocId])

    const onGetBolsForTableCurrentManCorrector = (isSelectedManCorrector) => {
        if (isSelectedManCorrector !== undefined) {
            const filteredCurrentManBols = isSelectedManCorrector?.bols;
            const findCurrentManBols = [];
            filteredCurrentManBols?.forEach(item => {
                findCurrentManBols.push({
                    bolId: item?.id,
                    label: item?.bol?.bookingRef,
                    grossWeight: item?.bol?.grossQuantity,
                    loadingOrderNumber: item?.bol?.cargoCase?.number,
                    loadingOrderDate: item?.bol?.dateOfLoading,
                    cargoDescriptionNowReads: item?.cargoDescriptionNowReads,
                    cargoDescriptionShouldReads: item?.cargoDescriptionShouldReads,
                    isChecked: true
                })
            })
            return findCurrentManBols;
        } else {
            return [];
        }
    }

    const formik = useFormik({
        initialValues: {
            number: "",
            manifest_id: selectedCargoCaseMan[0]?.id,
            correctionType: "",
            dateOfCorrection: "",
            portOfLoadingId: "",
            portOfDischargeId: "",
            vesselId: null,
            voyage: "",
            description: "",
            selectBols: isSelectedManCorrector !== undefined ? onGetBolsForTableCurrentManCorrector(isSelectedManCorrector) : [],
            vesselFlag_id: selectedCargoCaseMan[0]?.vesselFlag?.id
        },
        validationSchema: Yup.object({
            number: Yup.string()
                .required('Required field!'),
            manifest_id: Yup.string()
                .required('Required field!'),
            correctionType: Yup.string()
                .required('Required field!'),
            dateOfCorrection: Yup.string()
                .required('Required field!'),
            portOfLoadingId: Yup.number()
                .required('Required field!'),
            portOfDischargeId: Yup.number()
                .required('Required field!'),
            vesselId: Yup.string()
                .required('Required field!'),
            voyage: Yup.string()
                .required('Required field!'),
            description: Yup.string()
                .required('Required field!'),
            selectBols: Yup.array()
                .min(1, 'Min one bill of lading must be selected!')
                .required('Required field!'),
        }),
        onSubmit: values => onHandleAddManCorrector(values, selectedBolsArray)
    })

    function onGetNumberBols(currentManCorrector) {
        if (currentManCorrector !== undefined) {
           return currentManCorrector?.bols?.map(el => el?.bol?.bookingRef)
        } else return 'Bols show on in table';
    }

    useEffect(() => {
        if (formik.values.selectBols.length !== 0) {
            setActiveTable(true)
            setSelectedBolsArray([]);
            setBillOfLadingTable(formik.values.selectBols)
            setSumBolGrossWeight(formik.values.selectBols.map(el => el?.grossWeight).reduce((acc, el) => acc + el))
        } else {
            setActiveTable(false);
            setBillOfLadingTable([]);
            setSumBolGrossWeight(0);
            setSelectedBolsArray([]);
        }
    }, [formik.values.selectBols])

    return (
        <div className="create-doc-set-man-corrector-modal__container">
            <form onSubmit={formik.handleSubmit} className="create-doc-set-man-corrector-modal">
                <div className="create-doc-set-man-corrector-modal__title">
                    <div className="create-doc-set-man-corrector-modal__title-status">
                        <h3>MAN corrector</h3>
                        {isSelectedManCorrector !== undefined && <img className="create-doc-set-man-corrector-modal__title-status-image" src={findStatusDocument(isSelectedManCorrector?.status)} alt={'иконка'}/>}
                    </div>
                    <img className='create-doc-set-man-corrector-modal__title-image-close' onClick={onClose} src={closeIcon} alt={'иконка крестик'}/>
                </div>
                <div className="create-doc-set-man-corrector-modal-main-block">
                    <div className="create-doc-set-man-corrector-modal__templates-group-inputs">
                        <div className="create-doc-set-man-corrector-modal__templates-input">
                            <label>MAN corrector number</label>
                            <input className="create-doc-set-man-corrector-modal__templates-input-text"
                                   type={"text"}
                                   name={'number'}
                                   value={isSelectedManCorrector !== undefined ? isSelectedManCorrector?.number : formik.values.name}
                                   onChange={formik.handleChange}
                                   onBlur={formik.handleBlur}
                                   disabled={isSelectedManCorrector !== undefined}
                            />
                            {formik.errors.number && formik.touched.number ? <p className="create-doc-set-loading-order-modal-form-error">{formik.errors.number}</p> : null}
                        </div>
                        <div className="create-doc-set-man-corrector-modal__templates-input">
                            <label htmlFor="correctionType">MAN corrector type</label>
                            {isSelectedManCorrector !== undefined ? (
                                <input className="create-doc-set-man-corrector-modal__templates-input-text"
                                       type={"text"}
                                       value={isSelectedManCorrector?.correctionType}
                                       disabled={true}
                                />
                            ) : (
                                <CustomSelect
                                    options={optionCorrectionType}
                                    value={formik.values.correctionType.value}
                                    onChange={value => formik.setFieldValue('correctionType', value.value)}
                                />
                            )}
                            {formik.errors.correctionType && formik.touched.correctionType ? <p className="create-doc-set-loading-order-modal-form-error">{formik.errors.correctionType}</p> : null}
                        </div>
                        <div className="create-doc-set-man-corrector-modal__templates-input">
                            <label htmlFor="selectBols">Bill of lading number</label>
                            {isSelectedManCorrector !== undefined ? (
                                <input className="create-doc-set-man-corrector-modal__templates-input-text"
                                       type={"text"}
                                       value={onGetNumberBols(isSelectedManCorrector)}
                                       disabled={true}
                                />
                            ) : (
                            <CustomSelectIsMulti
                                options={optionsBols}
                                value={formik.values.selectBols}
                                onChange={value => formik.setFieldValue('selectBols', JSON.parse(JSON.stringify(value).replaceAll('"value"', '"bolId"')))}
                            />)}
                            {formik.errors.selectBols && formik.touched.selectBols ? <p className="create-doc-set-loading-order-modal-form-error">{formik.errors.selectBols}</p> : null}
                        </div>
                    </div>
                    <div className="create-doc-set-man-corrector-modal__table">
                        <div className="create-doc-set-man-corrector-modal__table-header">
                            <p></p>
                            <p>B/L №</p>
                            <p>Loading Order №</p>
                            <p>Loading Order Date</p>
                            <p>Gross weight</p>
                            <p>Cargo description now reads</p>
                            <p>Cargo description should read</p>
                        </div>
                        {billOfLadingTable.map((el) => {
                            return (
                                <div key={el?.bolId} className={isSelectedManCorrector !== undefined ? "create-doc-set-man-corrector-modal__table-row create-doc-set-man-corrector-modal__table-row-disabled" : "create-doc-set-man-corrector-modal__table-row"}>
                                    <p><img onClick={() => onHandleCheckTable(el?.bolId)} src={el?.isChecked ? activeCheckBoxIcon : emptyCheckBoxIcon} alt={'icon'}/></p>
                                    <p>{el?.label}</p>
                                    <p>{el?.loadingOrderNumber}</p>
                                    <p>{el?.loadingOrderDate}</p>
                                    <p>{el?.grossWeight}</p>
                                        <CargoDescriptionInputBlock
                                            bolId={el?.bolId}
                                            isChecked={el?.isChecked}
                                            cargoDescriptionNowReadsCurrentMan={el?.cargoDescriptionNowReads}
                                            cargoDescriptionShouldReadsCurrentMan={el?.cargoDescriptionShouldReads}
                                            isSelectedManCorrector={isSelectedManCorrector}
                                            selectedBolsArray={selectedBolsArray}
                                            setSelectedBolsArray={setSelectedBolsArray}
                                        />
                                </div>
                            )})}
                        {activeTable && <div className="create-doc-set-man-corrector-modal__table-total">
                            <p></p>
                            <p>Total</p>
                            <p>{isSumBolGrossWeight}</p>
                        </div>}
                    </div>
                    <div className="create-doc-set-man-corrector-modal__templates-group-inputs">
                        <div className="create-doc-set-man-corrector-modal__templates-input">
                            <label>Date</label>
                            <input className="create-doc-set-man-corrector-modal__templates-input-text"
                                   type={"date"}
                                   name={'dateOfCorrection'}
                                   value={isSelectedManCorrector !== undefined ? isSelectedManCorrector?.dateOfCorrection : formik.values.name}
                                   onChange={formik.handleChange}
                                   onBlur={formik.handleBlur}
                                   disabled={isSelectedManCorrector !== undefined}
                            />
                            {formik.errors.dateOfCorrection && formik.touched.dateOfCorrection ? <p className="create-doc-set-loading-order-modal-form-error">{formik.errors.dateOfCorrection}</p> : null}
                        </div>
                        <div className="create-doc-set-man-corrector-modal__templates-input">
                            <label htmlFor="portOfLoadingId">Port of Loading</label>
                            {isSelectedManCorrector !== undefined ? (
                                <input className="create-doc-set-man-corrector-modal__templates-input-text"
                                       type={"text"}
                                       value={isSelectedManCorrector?.portOfLoading?.name}
                                       disabled={true}
                                />
                            ) : (
                            <CustomSelect
                                options={optionPorts}
                                value={formik.values.portOfLoadingId}
                                onChange={value => formik.setFieldValue('portOfLoadingId', value.value)}
                            />)}
                            {formik.errors.portOfLoadingId && formik.touched.portOfLoadingId ? <p className="create-doc-set-loading-order-modal-form-error">{formik.errors.portOfLoadingId}</p> : null}
                        </div>
                        <div className="create-doc-set-man-corrector-modal__templates-input">
                            <label htmlFor="portOfDischargeId">Port of Discharge </label>
                            {isSelectedManCorrector !== undefined ? (
                                <input className="create-doc-set-man-corrector-modal__templates-input-text"
                                       type={"text"}
                                       value={isSelectedManCorrector?.portOfDischarge?.name}
                                       disabled={true}
                                />
                            ) : (
                            <CustomSelect
                                options={optionPorts}
                                value={formik.values.portOfDischargeId}
                                onChange={value => formik.setFieldValue('portOfDischargeId', value.value)}
                            />)}
                            {formik.errors.portOfDischargeId && formik.touched.portOfDischargeId ? <p className="create-doc-set-loading-order-modal-form-error">{formik.errors.portOfDischargeId}</p> : null}
                        </div>
                    </div>
                    <div className="create-doc-set-man-corrector-modal__templates-group-inputs">
                        <div className="create-doc-set-man-corrector-modal__templates-input">
                            <label htmlFor="vesselId">Vessel</label>
                            {isSelectedManCorrector !== undefined ? (
                                <input className="create-doc-set-man-corrector-modal__templates-input-text"
                                       type={"text"}
                                       value={isSelectedManCorrector?.vessel?.name}
                                       disabled={true}
                                />
                            ) : (
                            <CustomSelect
                                options={optionVessels}
                                value={formik.values.vesselId}
                                onChange={value => formik.setFieldValue('vesselId', value.value)}
                            />)}
                            {formik.errors.vesselId && formik.touched.vesselId ? <p className="create-doc-set-loading-order-modal-form-error">{formik.errors.vesselId}</p> : null}
                        </div>
                        <div className="create-doc-set-man-corrector-modal__templates-input">
                            <label>Voyage</label>
                            <input className="create-doc-set-man-corrector-modal__templates-input-text"
                                   type={"text"}
                                   name={'voyage'}
                                   value={isSelectedManCorrector !== undefined ? isSelectedManCorrector?.voyage : formik.values.name}
                                   onChange={formik.handleChange}
                                   onBlur={formik.handleBlur}
                                   disabled={isSelectedManCorrector !== undefined}
                            />
                            {formik.errors.voyage && formik.touched.voyage ? <p className="create-doc-set-loading-order-modal-form-error">{formik.errors.voyage}</p> : null}
                        </div>
                        <div className="create-doc-set-man-corrector-modal__templates-input">
                            <label>Description</label>
                            <input className="create-doc-set-man-corrector-modal__templates-input-text"
                                   type={"text"}
                                   name={'description'}
                                   value={isSelectedManCorrector !== undefined ? isSelectedManCorrector.description : formik.values.name}
                                   onChange={formik.handleChange}
                                   onBlur={formik.handleBlur}
                                   disabled={isSelectedManCorrector !== undefined}
                            />
                            {formik.errors.description && formik.touched.description ? <p className="create-doc-set-loading-order-modal-form-error">{formik.errors.description}</p> : null}
                        </div>
                    </div>
                </div>
                <div className="create-doc-set-man-corrector-modal__buttons">
                    <p className="create-doc-set-man-corrector-modal__buttons-message-error">{isModalMessage}</p>
                    <p className="create-doc-set-man-corrector-modal__buttons-message-error">{isModalMessageManCorrector}</p>
                    <button type={"button"} onClick={onClose} className="create-doc-set-man-corrector-modal__buttons-cancel">Cancel</button>
                    {/*<button type={"button"} className="create-doc-set-man-corrector-modal__buttons-send-to-sign">Annulate</button>*/}
                    {isSelectedManCorrector === undefined && <button type={"submit"} className="create-doc-set-man-corrector-modal__buttons-save">Save</button>}
                    {isSelectedManCorrector !== undefined && auth?.roles[0] === "CAPTAIN" && isSelectedManCorrector?.status === "DRAFT"
                        && <button onClick={() => setActiveModalDigitalSign(true)} type={"button"} className="create-doc-set-man-corrector-modal__buttons-save">Sign</button>}
                    {auth?.roles[0] === "FORWARDER" && isSelectedManCorrector?.status === "DRAFT"
                        && <button type={"button"} className="create-doc-set-man-corrector-modal__buttons-send-to-sign">Send to sign captain</button>}
                </div>
            </form>
            {activeModalDigitalSign && (
                <SignatureModal
                    description="Signature"
                    onCloseModal={() => onCloseModal(setActiveModalDigitalSign)}
                    onSend={onHandleSignManCorrector}
                    isModalMessage={isModalMessage}
                />
            )}
            {activeModalSuccess && (
                <SuccessModal
                    onCloseModal={() => onCloseModal(setActiveModalSuccess)}
                    isModalMessage={isModalMessage}
                />
            )}
        </div>
    )
}
export default CreateDocSetManCorrectorModal;